import { render, staticRenderFns } from "./CreateVolume.vue?vue&type=template&id=0c65539a&scoped=true"
import script from "./CreateVolume.vue?vue&type=script&lang=js"
export * from "./CreateVolume.vue?vue&type=script&lang=js"
import style0 from "./CreateVolume.vue?vue&type=style&index=0&id=0c65539a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c65539a",
  null
  
)

export default component.exports